import { Grid } from '@material-ui/core';
import { Button, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { AppraisalOrderDetails } from './appraisalOrderDetails';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type AppraisalOrderDetailsDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loanId?: number;
  collateralId?: number;
  propertyAppraisalId?: number;
  document: Document;
};

export const AppraisalOrderDetailsDialog = observer(
  (props: AppraisalOrderDetailsDialogProps) => {
    const { open, onClose, loanId, collateralId, propertyAppraisalId, document } = props;
    const taskId = document?.taskId;

    const getActions = () => {
      return (
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Button
              onClick={onClose}
              color="primary"
              variant="outlined"
              testId="cancel"
            >
              Close
            </Button>
          </Grid>
        </Grid>
      );
    }

    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            open={open}
            title="Appraisal Order Details"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={<AppraisalOrderDetails
              loanId={loanId}
              collateralId={collateralId}
              propertyAppraisalId={propertyAppraisalId}
            />}
            dialogActions={getActions()}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Appraisal Order Details"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={<AppraisalOrderDetails
              loanId={loanId}
              collateralId={collateralId}
              propertyAppraisalId={propertyAppraisalId}
            />}
            dialogActions={getActions()}
          />
        )}
      </>
    );
  }
);
